import { getUserAddress, getProfessions, getTitles } from "../../api/user";
import store from "@/store";

const getDefaultState = () => {
    return { details: {}, professions: [], titles: { prefix: [], suffix: [] } };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getUserAddress({ commit, state }) {
        return new Promise((resolve) => {
            if (Object.keys(state.details).length === 0) {
                commit("setLoading", true, { root: true });
            }
            getUserAddress()
                .then((response) => {
                    if (response.data.Status === 200) {
                        commit("setDetails", response.data.Result);
                        resolve();
                    } else {
                        store.cache.delete("user/getUserAddress");
                    }
                })
                .catch(() => {
                    store.cache.delete("user/getUserAddress");
                });
        });
    },
    getProfessions({ commit, state }) {
        return new Promise((resolve) => {
            if (state.professions.length === 0) {
                commit("setLoading", true, { root: true });
            }
            getProfessions().then((response) => {
                if (response.data.Status === 200) {
                    commit("setProfessions", response.data.Result);
                    resolve();
                }
            });
        });
    },
    getTitles({ commit, state }) {
        return new Promise((resolve) => {
            if (state.titles.length === 0) {
                commit("setLoading", true, { root: true });
            }
            getTitles().then((response) => {
                if (response.data.Status === 200) {
                    commit("setTitles", response.data.Result);
                    resolve();
                }
            });
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setDetails(state, details) {
        state.details = details;
    },
    setProfessions(state, professions) {
        let professionsArray = [];
        for (let professionKey in professions) {
            professionsArray.push(professions[professionKey]);
        }
        state.professions = professionsArray;
    },
    setTitles(state, titles) {
        let prefixTitlesArray = [];
        for (let titlesKey in titles.Prefix) {
            prefixTitlesArray.push(titles.Prefix[titlesKey]);
        }
        let suffixTitlesArray = [];
        for (let titlesKey in titles.Suffix) {
            suffixTitlesArray.push(titles.Suffix[titlesKey]);
        }
        state.titles.prefix = prefixTitlesArray;
        state.titles.suffix = suffixTitlesArray;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
